
export default {
    name: 'ErrorModal',
    props: {
        messages: { type: Array, required: true },
        onClose: Function,
    },
};
